import { axiosInstance } from "../axiosUtil";

import getAuthHeader from "./GetAuthHeader";

class AuthService {
  login(u, p) {
    return axiosInstance
      .post("auth/login/", { email: u, password: p })
      .then((response) => {
        if (response.data.access_token) {
          // Squashing dict into a single user object
          response.data.user.isVoiceTalent = response.data.user.is_voice_talent;
          delete response.data.user.is_voice_talent;
          const user = {
            authToken: response.data.access_token,
            refreshToken: response.data.refresh_token,
            ...response.data.user,
          };
          sessionStorage.setItem("user", JSON.stringify(user));
          return user;
        }
        return response.data;
      });
  }

  logout() {
    const headers = {
      Authorization: getAuthHeader(),
    };
    axiosInstance.post("auth/logout/", null, { headers }).then(() => {
      sessionStorage.removeItem("user");
      return "SUCCESS";
    });
  }

  refreshAuthToken() {
    const user = JSON.parse(sessionStorage.getItem("user"));
    let data = {};
    if (user && user.refreshToken) {
      data.refresh = user.refreshToken;
    } else {
      return "ERROR";
    }

    return axiosInstance
      .post("/auth/token/refresh/", data)
      .then((response) => {
        if (response.data.access) {
          user.authToken = response.data.access;
          sessionStorage.setItem("user", JSON.stringify(user));
          return "SUCCESS";
        }

        return "ERROR";
      })
      .catch((err) => {
        return "ERROR";
      });
  }
}

export default new AuthService();
